// Selectors
import { ApplicationState } from '../../store';


export const maintenanceSelector = (state: ApplicationState) => state.maintenanceState


